import React from 'react';
import { Cpu, Satellite, MonitorSmartphone, BarChart3 } from 'lucide-react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      icon: <Cpu size={28} />,
      title: 'Instalación de Hardware',
      description: 'Nuestros técnicos homologados instalan los dispositivos GPS y sensores telemáticos de forma oculta y segura en cada vehículo de tu flota.'
    },
    {
      icon: <Satellite size={28} />,
      title: 'Conexión Satelital Ininterrumpida',
      description: 'El vehículo comienza a transmitir datos cifrados (ubicación, velocidad, motor) en tiempo real mediante redes 4G/LTE hacia nuestra nube.'
    },
    {
      icon: <MonitorSmartphone size={28} />,
      title: 'Recepción en Plataforma',
      description: 'Accedes a tu Dashboard desde cualquier PC o móvil. Visualizas la flota en el mapa y configuras geocercas, alertas TTS y reglas de control.'
    },
    {
      icon: <BarChart3 size={28} />,
      title: 'Análisis y Optimización',
      description: 'El sistema procesa la información y te entrega reportes automatizados, hábitos de conducción y semáforos de vencimiento para tomar decisiones.'
    }
  ];

  return (
    <section id="how-it-works" className="section">
      <div className="container">
        <div className="hiw-header">
          <h2 className="section-title">¿Cómo Funciona VillaTracking?</h2>
          <p className="section-subtitle">
            Un ecosistema tecnológico completo diseñado para ser transparente, 
            rápido de implementar y fácil de usar por tu equipo.
          </p>
        </div>

        <div className="hiw-content">
          <div className="hiw-steps">
            {steps.map((step, index) => (
              <div className="hiw-step-item" key={index}>
                <div className="hiw-step-number">{index + 1}</div>
                <div className="hiw-step-icon">{step.icon}</div>
                <div className="hiw-step-text">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="hiw-image">
            <img src={'/img/howitworks.png'} alt="Esquema de funcionamiento IoT VillaTracking" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;